{
  "profile": "Profil",
  "nbOfUsers": "Nombre d'utilisateurs",
  "validation": {
    "name": "Le nom du profil est obligatoire",
    "maxLength": "Le nom doit faire 50 caractères maximum"
  },
  "roles": "Rôles",
  "name": "Nom du profil",
  "empty": "Aucun rôle disponible",
  "confirmDelete": {
    "title": "Suppression d'un profil",
    "description": "Le profil sélectionné \"{userProfileName}\" sera supprimé"
  },
  "cannotDelete": {
    "title": "Suppression du profil impossible",
    "description": "Le profil sélectionné \"{userProfileName}\" est associé à {usersCount} utilisateur(s)"
  },
  "button": {
    "delete": "Supprimer le profil"
  },
  "identity": "Identité",
  "new": "Nouveau profil",
  "label": {
    "operator": "Superviseur",
    "administrator": "Administrateur",
    "delegable_auditor": "Auditeur",
    "delegable_operator": "Exploitant"
  }
}
